export const borderWidths = {
  none: '0',
  thin: '1px',
  medium: '2px',
  thick: '4px',
};

export const borderStyles = {
  none: 'none',
  solid: 'solid',
  dashed: 'dashed',
  dotted: 'dotted',
};

export const borders = {
  default: {
    width: '1px',
    style: 'solid',
    color: 'neutral.300',
  },
  focus: {
    width: '2px',
    style: 'solid',
    color: 'primary.500',
  },
  error: {
    width: '1px',
    style: 'solid',
    color: 'error.500',
  },
  success: {
    width: '1px',
    style: 'solid',
    color: 'success.500',
  },
  warning: {
    width: '1px',
    style: 'solid',
    color: 'warning.500',
  },
  disabled: {
    width: '1px',
    style: 'solid',
    color: 'neutral.200',
  },
}; 